import { SVGProps } from "react";
import * as React from "react";

interface LoaderProps extends SVGProps<SVGSVGElement> {
  isTopLoader?: boolean; // Optional field, defaults to false
}

const Loader: React.FC<LoaderProps> = ({ isTopLoader = false, ...props }) => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  let width = props.width;
  let height = props.height;
  if (isMobile) {
    width = isTopLoader ? 35 : 42;
    height = isTopLoader ? 35 : 42;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={isMobile  ? "28 30 42 42" : "0 0 100 100"}
      preserveAspectRatio="xMidYMid"
      width={width ?? "100"}
      height={height ?? "100"}
      fontStyle="shape-rendering: auto; display: block; background: rgba(210, 211, 212, 0);"
      className={props.className}
    >
      <rect fill="#525659" height="10" width="4" ry="2.5" rx="2" y="33" x="48">
        <animate
          repeatCount="indefinite"
          begin="-0.875s"
          dur="1s"
          keyTimes="0;1"
          values="1;0"
          attributeName="opacity"
        ></animate>
      </rect>
      <g transform="rotate(45 50 50)">
        <rect
          fill="#525659"
          height="10"
          width="4"
          ry="2.5"
          rx="2"
          y="33"
          x="48"
        >
          <animate
            repeatCount="indefinite"
            begin="-0.75s"
            dur="1s"
            keyTimes="0;1"
            values="1;0"
            attributeName="opacity"
          ></animate>
        </rect>
      </g>
      <g transform="rotate(90 50 50)">
        <rect
          fill="#525659"
          height="10"
          width="4"
          ry="2.5"
          rx="2"
          y="33"
          x="48"
        >
          <animate
            repeatCount="indefinite"
            begin="-0.625s"
            dur="1s"
            keyTimes="0;1"
            values="1;0"
            attributeName="opacity"
          ></animate>
        </rect>
      </g>
      <g transform="rotate(135 50 50)">
        <rect
          fill="#525659"
          height="10"
          width="4"
          ry="2.5"
          rx="2"
          y="33"
          x="48"
        >
          <animate
            repeatCount="indefinite"
            begin="-0.5s"
            dur="1s"
            keyTimes="0;1"
            values="1;0"
            attributeName="opacity"
          ></animate>
        </rect>
      </g>
      <g transform="rotate(180 50 50)">
        <rect
          fill="#525659"
          height="10"
          width="4"
          ry="2.5"
          rx="2"
          y="33"
          x="48"
        >
          <animate
            repeatCount="indefinite"
            begin="-0.375s"
            dur="1s"
            keyTimes="0;1"
            values="1;0"
            attributeName="opacity"
          ></animate>
        </rect>
      </g>
      <g transform="rotate(225 50 50)">
        <rect
          fill="#525659"
          height="10"
          width="4"
          ry="2.5"
          rx="2"
          y="33"
          x="48"
        >
          <animate
            repeatCount="indefinite"
            begin="-0.25s"
            dur="1s"
            keyTimes="0;1"
            values="1;0"
            attributeName="opacity"
          ></animate>
        </rect>
      </g>
      <g transform="rotate(270 50 50)">
        <rect
          fill="#525659"
          height="10"
          width="4"
          ry="2.5"
          rx="2"
          y="33"
          x="48"
        >
          <animate
            repeatCount="indefinite"
            begin="-0.125s"
            dur="1s"
            keyTimes="0;1"
            values="1;0"
            attributeName="opacity"
          ></animate>
        </rect>
      </g>
      <g transform="rotate(315 50 50)">
        <rect
          fill="#525659"
          height="10"
          width="4"
          ry="2.5"
          rx="2"
          y="33"
          x="48"
        >
          <animate
            repeatCount="indefinite"
            begin="0s"
            dur="1s"
            keyTimes="0;1"
            values="1;0"
            attributeName="opacity"
          ></animate>
        </rect>
      </g>
    </svg>
  );
};

export default Loader;
